import { ServiceRoute, GLServiceBase } from "../../src/commonui/services/service";
class AccountServiceClass extends GLServiceBase<any, any> {
	serviceRoute: ServiceRoute = { prefix: "account/v1/users", itemSuffix: "{id}" };
	bindingUserByEmailUrl = "{email}/binding";

	validateEmail(params: any) {
		return this.get("{email}/confirmation", params);
	}

	bindingUserByEmail(params: any) {
		return this.request
			.post(this.url(this.bindingUserByEmailUrl), params)
			.catch
			//(customError(this, HttpMethod.Post, `${this.serviceRoute.prefix}/${this.bindingUserByEmailUrl}`))
			();
	}

	getUserAvatarUrl(id, expirationminutes) {
		return this.get("{id}/getuseravatarsasuri/{expirationminutes}", null, { id, expirationminutes });
	}

	getUsers(params: any): Promise<{ data: any }> {
		return this.request.get(this.url("getUsersByRole"), params);
	}

	isTestingAllowed(userId: string): Promise<boolean> {
		return this.get("istestingallowed", { id: userId });
	}
}

export const AccountService = new AccountServiceClass();
